import { useState } from 'react'

export default function OrganizationForm({ organization, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: organization?.Name || '',
    InternalIdentifier: organization?.InternalIdentifier || '',
    Description: organization?.Description || '',
    IsDeleted: false
  })

  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = {}
    if (!formData.Name.trim()) newErrors.Name = 'Name is required'
    if (!formData.InternalIdentifier.trim()) newErrors.InternalIdentifier = 'Internal identifier is required'
    return newErrors
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = validate()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
    onSubmit(formData)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: undefined }))
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Organization Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="Name"
          value={formData.Name}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., Acme Corp"
        />
        {errors.Name && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.Name}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Internal Identifier <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="InternalIdentifier"
          value={formData.InternalIdentifier}
          onChange={handleChange}
          disabled={!!organization}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
          placeholder="e.g., acme-corp"
        />
        {errors.InternalIdentifier && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.InternalIdentifier}</p>}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Unique identifier for this organization. Cannot be changed after creation.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          name="Description"
          value={formData.Description}
          onChange={handleChange}
          rows={3}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="Brief description of this organization"
        />
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition disabled:opacity-50 flex items-center space-x-2"
        >
          {loading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          <span>{organization ? 'Update' : 'Create'} Organization</span>
        </button>
      </div>
    </form>
  )
}
